import request from '@utils/request'
import configRequest from "@src/config/request";
import axios from 'axios'

import { getCookie, saveCookie } from '@utils/cookie'
import { saveLocalStorage } from '@utils/localStorage'

export const state = {
  currentMember: getCookie('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentMember = newValue
    saveCookie('auth.currentUser', newValue)
    saveLocalStorage('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  loggedIn(state) {
    return !!state.currentMember
  },
  isDealer(state, getters) {
    return getters.loggedIn && state.currentMember.group === '經銷會員'
  },
}

export const actions = {
  init({ state }) {
    setDefaultAuthHeaders(state)
  },

  forgetPassword({ commit, dispatch, getters }, { email } = {}) {
    return request.post(
      '/password/email',
      {
        email,
      },
      {
        ...configRequest,
        name: 'fetchBrands',
        customErrorHandle: () => {
        }
      }
    )
  },
  resetPassword({ commit, dispatch, getters }, { password, passwordConfirm, token } = {}) {
    return request.post(
      '/password/reset',
      {
        password,
        passwordConfirm,
        token,
      },
      {
        ...configRequest,
        name: 'resetPassword',
        customErrorHandle: () => {
        }
      }
    )
  },

  setCurrentUser({ commit, dispatch, getters }, user) {
    commit('SET_CURRENT_USER', user)
  },

  logIn({ commit, dispatch, getters }, { mobilePhoneCode, mobilePhone, verificationCode } = {}) {
    return request
      .post(
        '/user/login',
        {
          mobilePhoneCode, mobilePhone, verificationCode
        },
        {
          ...configRequest,
          name: 'logIn',
          customErrorHandle: () => {
          }
        }
      )
      .then((response) => {
        // if (!response.items.hasOwnProperty('user_name')) return { status: 'USER_NEED_RESET_PASSWORD', token:
        // response.items.token }
        const member = response.items
        commit('SET_CURRENT_USER', member)

        return member
      })
  },

  logOut({ commit }) {
    return request.get('/user/logout', {
      ...configRequest,
      name: 'logOut',
    })
      .then((response) => {
        commit('SET_CURRENT_USER', null)

        return response
      })
  },

  getCode({ commit, state }, submitData) {
    return request.post('/user/getCode', submitData, {
      ...configRequest,
      name: 'getCode',
    })
      .then((response) => response.items.uuid)
  },

  validateEmail({ commit, state }, submitData) {
    return request.post('/user/checkEmail', submitData, {
      ...configRequest,
      name: 'validateEmail',
      customErrorHandle: () => {
      }
    })
  },

  validatePhone({ commit, state }, submitData) {
    return request.post('/user/checkMobilePhone', submitData, {
      ...configRequest,
      name: 'validatePhone',
    })
  },

  register({ commit, state }, submitData) {
    return request.post('/user/register', submitData, {
      ...configRequest,
      name: 'register',
      customErrorHandle: () => {
      }
    })
      .then((response) => {
        const member = response.items
        // commit('SET_CURRENT_USER', member);

        return member
      })
  },

  /* socialLogin({ commit, dispatch, getters }, { social, accessToken, merchantAlias } = {}) {
   return request
   .post(`/user/login/facebook/callback`, { access_token: accessToken }, {customErrorHandle: ()=>{}})
   .then((response) => {
   const member = response.items;
   commit('SET_CURRENT_USER', member);

   return member
   })
   },

   socialRegister({ commit, dispatch, getters }, submitData) {
   return request
   .post(`/merchant/member/register/${submitData.social}`, submitData)
   .then((response) => {
   const member = response.items;
   commit('SET_CURRENT_USER', member);

   return member
   })
   },

   activeUser({ commit, dispatch, getters }, token) {
   return request.get(`/user/activate/${token}`, {customErrorHandle: ()=>{}})
   }, */

  storeUser({ commit, dispatch, getters }, submitData) {
    return request.post(`/user/store`, submitData, {
      ...configRequest,
      name: 'storeUser',
    })
      .then((response) => {
        const member = response.items

        /* commit('SET_CURRENT_USER', {
         ...state.currentMember,
         ...member,
         }) */

        return response.items
      })
  },

  fetchUser({ commit, dispatch, getters }) {
    return request.get(`/user/profile`, {
      ...configRequest,
      name: 'fetchUser',
      customErrorHandle: () => {
      }
    })
      .then((response) => {
        const member = response.items

        commit('SET_CURRENT_USER', {
          ...state.currentMember,
          ...member,
          // groupId: 6
        });

        return response.items
      })
  },

  bindLineAccount({ commit }, lineId) {
    return request.post(`/user/lineBind`, { lineId }, {
      ...configRequest,
      name: 'bindLineAccount',
    })
  },

  fetchUserByUUID({ commit, dispatch, getters }, uuid) {
    return request.get(`/user/profile/${ uuid }`, {
      ...configRequest,
      name: 'fetchUserByUUID',
      customErrorHandle: () => {
      }
    })
      .then((response) => response.items)
  },

  storeOldUser({ commit, dispatch, getters }, submitData) {
    return request.post(`/user/oldUserUpdate`, submitData, {
      ...configRequest,
      name: 'storeOldUser',
    })
      .then((response) => {
        const member = response.items
        commit('SET_CURRENT_USER', member)

        return response.items
      })
  },
}

// ===
// Private helpers
// ===

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentMember
    ? `Bearer ${ state.currentMember.token }`
    : ''
}
